import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      {/* Header */}
      <header className="bg-[#1A1A1A] border-b border-gray-800 py-4">
        <div className="container mx-auto px-4">
          <Link to="/" className="text-2xl font-bold bg-gradient-to-r from-[#00D9FF] to-[#0088FF] bg-clip-text text-transparent">
            WTPL
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-[#00D9FF] to-[#0088FF] bg-clip-text text-transparent">
          Términos de Servicio
        </h1>
        
        <p className="text-gray-400 mb-8">Última actualización: Febrero 2025</p>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Aceptación de los Términos</h2>
            <p>
              Al acceder y utilizar WTPL ("Welcome To Planet LYO"), usted acepta estar sujeto a estos 
              Términos de Servicio. Si no está de acuerdo con alguna parte de estos términos, no podrá 
              acceder al servicio.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Descripción del Servicio</h2>
            <p>
              WTPL es una plataforma de suscripción que permite a los DJs acceder y descargar contenido 
              musical para uso en presentaciones profesionales. El servicio incluye:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Acceso a biblioteca de tracks musicales</li>
              <li>Herramientas de organización (Crates)</li>
              <li>Sistema de búsqueda y filtrado</li>
              <li>Reproductor de audio con visualización</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Registro y Cuenta</h2>
            <p>
              Para utilizar WTPL, debe crear una cuenta proporcionando información precisa y completa. 
              Usted es responsable de:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Mantener la confidencialidad de su cuenta</li>
              <li>Todas las actividades que ocurran bajo su cuenta</li>
              <li>Notificarnos inmediatamente de cualquier uso no autorizado</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Suscripción y Pagos</h2>
            <p>
              El acceso completo a WTPL requiere una suscripción mensual de $4.99 USD. Los pagos se 
              procesan a través de Stripe. La suscripción se renueva automáticamente hasta que sea 
              cancelada. No se ofrecen reembolsos por períodos parciales.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Uso Aceptable</h2>
            <p className="mb-2">Usted se compromete a NO:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Compartir su cuenta con terceros</li>
              <li>Redistribuir, revender o sublicenciar el contenido descargado</li>
              <li>Utilizar el servicio para fines ilegales</li>
              <li>Intentar hackear, descompilar o realizar ingeniería inversa del servicio</li>
              <li>Subir contenido que infrinja derechos de autor de terceros</li>
              <li>Usar bots o scripts automatizados para acceder al servicio</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Contenido y Propiedad Intelectual</h2>
            <p>
              WTPL actúa como una plataforma de distribución. El contenido disponible en la plataforma 
              es proporcionado por usuarios, artistas y socios. WTPL no reclama propiedad sobre el 
              contenido subido por usuarios.
            </p>
            <p className="mt-2">
              Al subir contenido, usted garantiza que tiene los derechos necesarios para distribuirlo 
              y otorga a WTPL una licencia no exclusiva para almacenar y distribuir dicho contenido 
              a los suscriptores.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. DMCA y Derechos de Autor</h2>
            <p>
              WTPL respeta los derechos de propiedad intelectual y cumple con la Ley de Derechos de 
              Autor del Milenio Digital (DMCA). Si cree que su contenido ha sido infringido, consulte 
              nuestra <Link to="/dmca" className="text-cyan-400 hover:underline">Política DMCA</Link>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Limitación de Responsabilidad</h2>
            <p>
              WTPL se proporciona "tal cual" sin garantías de ningún tipo. No seremos responsables 
              por daños indirectos, incidentales, especiales o consecuentes que resulten del uso o 
              la imposibilidad de usar el servicio.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Terminación</h2>
            <p>
              Podemos suspender o terminar su cuenta en cualquier momento si viola estos términos. 
              Usted puede cancelar su suscripción en cualquier momento desde su cuenta.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Cambios a los Términos</h2>
            <p>
              Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios 
              entrarán en vigor inmediatamente después de su publicación. El uso continuado del 
              servicio constituye aceptación de los nuevos términos.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">11. Contacto</h2>
            <p>
              Para preguntas sobre estos Términos de Servicio, contáctenos en:{' '}
              <a href="mailto:planetlyo@gmail.com" className="text-cyan-400 hover:underline">
                planetlyo@gmail.com
              </a>
            </p>
          </section>
        </div>

        {/* Back Link */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <Link to="/" className="text-cyan-400 hover:underline">
            ← Volver al inicio
          </Link>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;
